module.exports = __webpack_public_path__ + "img/customer-landing-page-default@2x.32035b22.png";